import colorPattern from '../../colors'

const lightBorderColors = {
    'border-primary': colorPattern.onyx,
    'border-secondary': colorPattern.keshi,
    'border-tertiary': colorPattern.moon,
    'border-invert': colorPattern.pearl,
    'border-brand-primary': colorPattern.cyan,
    'border-brand-secondary': colorPattern.violet,
} as const

export default lightBorderColors
